import React, { Component } from 'react';
import { BasicHeader } from '../../../components/basic_header';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { message, Button } from 'antd';
import Form from '../../../lib/ui/form';

const data_type_schema = [
    {
        index: "name",
        name: "Name",
        type: 'text',
        // help_text:"Hello i am help text"
    }, {
        index: 'description',
        name: "Description",
        type: 'textarea'
    },
    {
        index: "debit_balance",
        name: "Add Debit Balance",
        type: 'bool',
        help_text: "Debit amount should be added or substracted? True to Add."
    },
    {
        index: 'transfer_expression',
        name: "Transfer Expression",
        type: 'text',
        help_text: "Expression to transfer transactions"
    },
    {
        index: 'fields_config',
        name: "Field Config",
        type:'basicconfig',
        multiple:true,
        count:1,
        min:0,
        isDraggable: true,
        toggle_ui_json:true,
    },
    {
        index:'expression_note',
        name:"Expression Notes",
        type:'text',
        multiple:true,
        count:1,
        min:0
    }

]
class DatatypeAdd extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_data:this.props.edit_data||{},
            edit_id:this.props.edit_id,
        }

        this.group_id = props.match.params.group_id;


        this.post_datatype = RESTExecutor.post().config({
            label: 'data_types'
        })
            .callbacks((success) => {
                this.setState({
                    edit_id: null,
                    form_data: {}
                });
                message.success("Datatype Added");
                this.props.history.goBack()
            
            })
            .connect(props.domains.datatype);

        this.patch_datatype = RESTExecutor.patch().config({
            label: 'data_types_detail'
        })
            .callbacks((success) => {
                this.setState({
                    edit_id: null,
                    form_data: {}
                });
                message.success("Datatype Updated");
                this.props.history.goBack()
            })
            .connect(props.domains.datatype);
    }

    handlePostPatch = (data) => {

        if (this.state.edit_id) {
            this.patch_datatype.forId(this.state.edit_id).execute({
                ...data,
                group_id: this.group_id
            });
        } else {
            this.post_datatype.execute({
                ...data,
                group_id: this.group_id
            });
        }
    }

    render() {
        const {form_data,edit_id}=this.state;
        let post_datatype_resp = this.post_datatype.response();
        let patch_datatype_resp = this.patch_datatype.response();
        let networkState=edit_id?patch_datatype_resp:post_datatype_resp;

        return (
            <div>  
            <BasicHeader
            title={`Datatype ${this.props.edit_id?"Edit":"Add"}`}
            /> 

            <div className='filter-card'>
            <Form
            forCreate={edit_id?true:false}
            initialData={form_data}
            parentData={form_data}
            submitted={this.state.submitted}
            onChange={ (data)=>{
                this.setState({form_data:data})
            }}
            fields={data_type_schema}
            errorMessage={networkState.error_message }
            validationErrors={networkState.validation_errors }
          />
          <div style={{
              display:'flex',
              flexDirection:'row',
              justifyContent:'space-between',
              paddingTop:20
          }}>
               <Button key='cancel' type='danger'
            disabled={networkState.fetching}
            onClick={() => {
              this.props.history.goBack()
            }}>
            {/* <CloseOutlined type='close'/> */}
            Cancel
          </Button>
           <Button key='submit' type='primary'
           disabled={networkState.fetching}
           loading={networkState.fetching}
           onClick={() => {
             this.setState({submitted: true});
             this.handlePostPatch(form_data)
           }}>
           {/* <CheckOutlined type='check' /> */}
           {this.props.okText||"Submit"}
           {/* Submit */}
         </Button>

          </div>
            </div>

            
            </div>
        );
    }
}

export default withDomains(DatatypeAdd,"datatype");
